export default "__VITE_ASSET__Bb0_IR0D__"